import React, { useEffect } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import './messageBar.css'
import {
  DoneOutline,
  ErrorOutline,
  Info,
  ReportProblem,
} from '@mui/icons-material'

interface Props {
  id?: string
  open: boolean
  setOpen: (estado: boolean) => void
  status: number
  text: string | JSX.Element
  autoClose?: number
  adjustin: boolean
}

const MessageBar: React.FC<Props> = ({
  id,
  open,
  setOpen,
  status,
  text,
  autoClose,
  adjustin,
}) => {
  useEffect(() => {
    if (open && autoClose) {
      const interval = setTimeout(() => {
        setOpen(false)
      }, autoClose)
      return () => clearTimeout(interval)
    }
  }, [open, autoClose, setOpen])

  const getMsgContainerClassname = (): string => {
    let classname = ''
    switch (status) {
      case 0:
        classname = 'success'
        break
      case 1:
        classname = 'error'
        break
      case 2:
        classname = 'warning'
        break
      default:
        classname = 'info'
        break
    }

    return `${classname} ${
      adjustin ? 'containerMessageBoxAdj' : 'containerMessageBox'
    }`
  }

  const getIcon = () => {
    const className = adjustin ? 'iconMessageAdj' : 'iconMessage'
    switch (status) {
      case 0:
        return <DoneOutline className={className} />
      case 1:
        return <ErrorOutline className={className} />
      case 2:
        return <ReportProblem className={className} />

      default:
        return <Info className={className} />
    }
  }

  if (open) {
    return (
      <Container id="message-container" className={getMsgContainerClassname()}>
        <Grid
          alignItems="center"
          container={true}
          direction="row"
          id={id ? id : 'container-message'}
        >
          <Grid container={true}>
            <Grid item={true}>
              <Typography variant="body2" color="inherit">
                {getIcon()}
                {text}
              </Typography>

              <IconButton
                key="close"
                aria-label="close"
                id="close-message"
                color="inherit"
                data-testid="close-barmessage"
                className={
                  adjustin ? 'iconCloseMessageAdj' : 'iconCloseMessage'
                }
                onClick={() => {
                  setOpen(false)
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    )
  }
  return null
}

export default MessageBar
